<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e582">
<div class="tx44">
<p class="tx14" id="d41151731">I am indebted to the writer and broadcaster Stephen</p>
<p class="tx14" id="d41151732">Fry for his comments; to Kim Harris and Sarah</p>
<p class="tx14" id="d41151733">Williams for their overpowering good taste and</p>
<p class="tx14" id="d41151734">intelligence; to my literary agent Anthony Goff, who</p>
<p class="tx14" id="d41151735">has been unstinting in his support and</p>
<p class="tx14" id="d41151736">encouragement; to my theatrical agent Lorraine</p>
<p class="tx14" id="d41151737">Hamilton, for not minding that I also have a literary</p>
<p class="tx14" id="d41151738">agent, and to my wife Jo, for things that would fill a</p>
<p class="tx14" id="d41151739">longer book than this.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap7_thegunse_9781569478004_epub_part7.vue?5fc18d7f